<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Currency Payment"
            bc1="App"
            bc2="Currency Payment"
            bc3="List"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="
                      $router.push({ name: 'currency-payment-method-add' })
                    "
                  >
                    <span class="text-nowrap">Add Record</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- data modal starts -->
          <currencyModal
            :show="showModal"
            :currencyKey="currencyKey"
            @hide="showModal = false"
            :currencyData="currencyData"
          ></currencyModal>
          <!-- data modal Ends -->
          <CommonTable
            :url="url"
            :tableHeaderValues="tableHeaderValues"
            :actions="actions"
            :deleteActions="deleteActions"
            :mutedData="mutedData"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import currencyModal from "@/components/common/modals/currencyPaymentShowDataModal.vue";

export default {
  components: {
    CommandIcon,
    currencyModal
  },
  created() {},
  mounted() {
    localStorage.setItem("url", "v1/get-currency-payment-method");
    this.checkDataInStore('v1/get-currency-payment-method')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-currency-payment-method",
      storageKey: "currencyPayment",
      showModal: false,
      currencyData: [],
      currencyKey: [],
      tableHeaderValues: [
        {
          title: "Currency name",
          valueKey: "currency.name"
        },
        {
          title: "Payment Name",
          valueKey: "payment_method.name"
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }

            if (row.is_default == 1) {
              html += '<span class="badge badge-secondary ml-1">Default</span>';
            }

            return html;
          }
        }
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "currencyPaymentUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "currency-payment-method-update" });
          }
        },
        {
          title: "Show Data",
          class: "btn-primary  ml-1",
          modalId: "v-b-modal.modal-primary",
          cta: (row, index) => {
            this.showData(row, index);
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "paymentMethodDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    showData(row) {
      this.showModal = true;
      if (row.data !== null && row.data != "[]" ) {
        if (typeof row.data == "object") {
          let currencyKey = Object.keys(row.data);
          let data = row.data;
          this.currencyData = data;
          this.currencyKey = currencyKey;
        } else if (typeof row.data == "string") {
          let currencyData = JSON.parse(row.data);
          // let currencyKey = Object.keys(currencyData[0]);
          let currencyKey = Object.keys(currencyData);
          // let data = currencyData[0];
          let data = currencyData;
          this.currencyData = data;
          this.currencyKey = currencyKey;
        }
      } else {
        this.currencyData = [];
        this.currencyKey = [];
      }
    },
    close() {
      this.currencyData = "";
      this.showModal = false;
    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-currency-payment-method", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("currencyPayment");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "currencyPayment";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>

<style>

</style>
